import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';

import { TTP_HISTORY } from 'SharedDir/backend/endpoints/ttp-history';
import { TtpHistory } from 'SharedDir/declarations/ttp-history';

export default class TtpHistoryApiClass {
  protected readonly endpoints = TTP_HISTORY;

  // person.history
  public async getPersonHistory(id: number, params: any) {
    const endpoint = this.endpoints.PERSON(id);

    const { data } = (await http({
      ...endpoint,
      params,
    })) as AxiosResponse<TtpHistory.HistoryItem[]>;

    return data;
  }

  // identity_document.history
  public async getPersonIdentityDocumentHistory(id: number, params: any) {
    const endpoint = this.endpoints.PERSON_IDENTITY_DOCUMENT(id);

    const { data } = (await http({
      ...endpoint,
      params,
    })) as AxiosResponse<TtpHistory.HistoryItem[]>;

    return data;
  }

  // ttp_economic_agreement.history
  public async getPersonEconomicAgreementHistory(id: number, params: any) {
    const endpoint = this.endpoints.PERSON_ECONOMIC_AGREEMENT(id);

    const { data } = (await http({
      ...endpoint,
      params,
    })) as AxiosResponse<TtpHistory.HistoryItem[]>;

    return data;
  }

  // person.history
  public async getPersonDeerHistory(id: number, params: any) {
    const endpoint = this.endpoints.PERSON_DEER(id);

    const { data } = (await http({
      ...endpoint,
      params,
    })) as AxiosResponse<TtpHistory.HistoryItem[]>;

    return data;
  }

  // file.history
  public async getFilesHistory(id: number, params: any) {
    const endpoint = this.endpoints.FILES(id);

    const { data } = (await http({
      ...endpoint,
      params,
    })) as AxiosResponse<TtpHistory.HistoryItem[]>;

    return data;
  }

  // ttp_organization.history
  public async getOrganizationHistory(id: number, params: any) {
    const endpoint = this.endpoints.ORGANIZATION(id);

    const { data } = (await http({
      ...endpoint,
      params,
    })) as AxiosResponse<TtpHistory.HistoryItem[]>;

    return data;
  }

  // ttp_organization.history
  public async getOrganizationFoundersHistory(id: number, params: any) {
    const endpoint = this.endpoints.ORGANIZATION_FOUNDERS(id);

    const { data } = (await http({
      ...endpoint,
      params,
    })) as AxiosResponse<TtpHistory.HistoryItem[]>;

    return data;
  }

  // ttp_organization.history
  public async getOrganizationWorkersHistory(id: number, params: any) {
    const endpoint = this.endpoints.ORGANIZATION_WORKERS(id);

    const { data } = (await http({
      ...endpoint,
      params,
    })) as AxiosResponse<TtpHistory.HistoryItem[]>;

    return data;
  }

  // ttp_organization.history
  public async getOrganizationGovSupportHistory(id: number, params: any) {
    const endpoint = this.endpoints.ORGANIZATION_GOV_SUPPORT(id);

    const { data } = (await http({
      ...endpoint,
      params,
    })) as AxiosResponse<TtpHistory.HistoryItem[]>;

    return data;
  }

  // ttp_organization.history
  public async getOrganizationMtsHistory(id: number, params: any) {
    const endpoint = this.endpoints.ORGANIZATION_MTS(id);

    const { data } = (await http({
      ...endpoint,
      params,
    })) as AxiosResponse<TtpHistory.HistoryItem[]>;

    return data;
  }

  // ttp_organization.history
  public async getOrganizationQuotasHistory(id: number, params: any) {
    const endpoint = this.endpoints.ORGANIZATION_QUOTAS(id);

    const { data } = (await http({
      ...endpoint,
      params,
    })) as AxiosResponse<TtpHistory.HistoryItem[]>;

    return data;
  }

  // ttp_organization.history
  public async getOrganizationTerritoryHistory(id: number, params: any) {
    const endpoint = this.endpoints.ORGANIZATION_TERRITORY(id);

    const { data } = (await http({
      ...endpoint,
      params,
    })) as AxiosResponse<TtpHistory.HistoryItem[]>;

    return data;
  }

  // ttp_organization.history
  public async getOrganizationBuildingHistory(id: number, params: any) {
    const endpoint = this.endpoints.ORGANIZATION_BUILDING(id);

    const { data } = (await http({
      ...endpoint,
      params,
    })) as AxiosResponse<TtpHistory.HistoryItem[]>;

    return data;
  }
}
